/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // ========== Returns modal config (customise message and link here) ==========
  const RETURNS_CONFIG = {
    RETURNS_LINE_PREFIX: "We offer easy returns — ",
    RETURNS_TRIGGER_TEXT: "Learn more",
    RETURNS_TITLE: "RETURNS",
    RETURNS_MESSAGE: "If you're not completely satisfied with your purchase, you may return it within 30 days. Please see our following terms and conditions for full details.",
    RETURNS_LINK_URL: "/policies/refund-policy",
    RETURNS_LINK_TEXT: "following terms and conditions"
  };

  // ========== Returns modal: init, open, close ==========
  function initReturnsModal() {
    const line = document.querySelector('[data-returns-line]');
    const prefixEl = document.querySelector('[data-returns-prefix]');
    const triggerEl = document.querySelector('[data-open-returns-modal]');
    const modal = document.querySelector('[data-returns-modal]');
    const titleEl = document.querySelector('[data-returns-title]');
    const bodyEl = document.querySelector('[data-returns-body]');
    const closers = document.querySelectorAll('[data-close-returns-modal]');

    if (!line || !triggerEl || !modal || !titleEl || !bodyEl) return;
    if (modal.dataset.returnsInitialized === 'true') return;
    modal.dataset.returnsInitialized = 'true';

    prefixEl.textContent = RETURNS_CONFIG.RETURNS_LINE_PREFIX;
    triggerEl.textContent = RETURNS_CONFIG.RETURNS_TRIGGER_TEXT;
    titleEl.textContent = RETURNS_CONFIG.RETURNS_TITLE;

    const linkHtml = '<a href="' + RETURNS_CONFIG.RETURNS_LINK_URL + '" class="cart__drawer__returns-modal__link" target="_blank" rel="noopener">' + RETURNS_CONFIG.RETURNS_LINK_TEXT + '</a>';
    const messageWithLink = RETURNS_CONFIG.RETURNS_MESSAGE.replace(RETURNS_CONFIG.RETURNS_LINK_TEXT, linkHtml);
    bodyEl.innerHTML = '<p class="cart__drawer__returns-modal__message">' + messageWithLink + '</p>';

    var closeBtn = modal.querySelector('.cart__drawer__returns-modal__close');

    function openModal() {
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('is-open');
      triggerEl.setAttribute('aria-expanded', 'true');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('is-open');
      triggerEl.setAttribute('aria-expanded', 'false');
      triggerEl.focus();
    }

    triggerEl.addEventListener('click', openModal);
    closers.forEach(function(el) { el.addEventListener('click', closeModal); });
    modal.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  // ========== Cart counter: update cart drawer badge (header uses its own Totals) ==========
  function updateCartCount(count) {
    const num = count || 0;
    const drawerBadges = document.querySelectorAll('.cart__drawer [data-header-cart-count]');
    drawerBadges.forEach(function(el) {
      el.setAttribute('data-header-cart-count', String(num));
      el.textContent = String(num);
    });
    const headerCounts = document.querySelectorAll('.theme__header [data-header-cart-count]');
    headerCounts.forEach(function(el) {
      el.setAttribute('data-header-cart-count', String(num));
      if (el.closest('.cart__status__parens')) {
        el.innerHTML = '(' + num + ')';
      } else {
        el.textContent = String(num);
      }
    });
    // Kept on its own attribute so theme.js Totals cannot rewrite it as "(n)"
    document.querySelectorAll('[data-cart-badge-count]').forEach(function(el) {
      el.setAttribute('data-cart-badge-count', String(num));
      el.textContent = String(num);
    });
    document.querySelectorAll('[data-header-cart-full]').forEach(function(el) {
      el.setAttribute('data-header-cart-full', num > 0 ? 'true' : 'false');
    });
  }

  // ========== Cart drawer: fetch and display product recommendations ==========
  // Uses Shopify Product Recommendations API (Search & Discovery app)
  function loadCartRecommendations(cart) {
    const container = document.querySelector('[data-cart-recommendations]');
    const contentEl = document.querySelector('[data-cart-recommendations-content]');
    if (!container || !contentEl) return;

    const productId = cart && cart.items && cart.items.length > 0 ? cart.items[0].product_id : null;

    if (!productId) {
      contentEl.innerHTML = '';
      container.classList.add('recommendations--empty');
      return;
    }

    container.classList.remove('recommendations--empty');

    const route = (window.theme && window.theme.routes && window.theme.routes.product_recommendations_url) || '/recommendations/products';
    const url = `${route}?section_id=api-cart-recommendations&product_id=${productId}&limit=4`;

    fetch(url)
      .then(function(r) { return r.ok ? r.text() : Promise.reject(r); })
      .then(function(html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const apiContent = doc.querySelector('[data-api-content]');
        contentEl.innerHTML = apiContent ? apiContent.innerHTML : '';
        if (window.Alpine && contentEl.children.length > 0) {
          window.Alpine.initTree(contentEl);
        }
      })
      .catch(function() {
        contentEl.innerHTML = '';
      });
  }

  document.addEventListener('theme:cart:change', function(event) {
    if (event.detail && event.detail.cart) {
      updateCartCount(event.detail.cart.item_count);
      loadCartRecommendations(event.detail.cart);
    }
  });

  function refreshCartUI() {
    fetch(((window.theme && window.theme.routes && window.theme.routes.cart) || '/cart') + '.js')
      .then(function(r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function(cart) {
        updateCartCount(cart.item_count);
        loadCartRecommendations(cart);
      })
      .catch(function() {});
  }

  document.addEventListener('theme:cart:drawer:html-loaded', function() {
    refreshCartUI();
    initReturnsModal();
    initCartDrawerAccordions();
  });

  // 8.2.0 theme.js always shows the add-to-cart popdown instead of opening
  // [data-drawer="drawer-cart"]. Match live: open the drawer with the item shown.
  document.addEventListener('theme:cart:popdown', function() {
    if (document.querySelector('[data-ajax-disable="false"]')) return;
    if (document.querySelector('[data-ajax-disable="true"]')) return;

    const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (!cartDrawer) return;

    // 8.2.0 does not await updateHeaderTotal, so the cart held in theme.js is
    // still the pre-add cart at this point. Publish the fresh one before rendering.
    fetch(((window.theme && window.theme.routes && window.theme.routes.cart) || '/cart') + '.js')
      .then(function(r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function(cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          detail: { cart: cart },
          bubbles: true
        }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
        updateCartCount(cart.item_count);
        loadCartRecommendations(cart);
        initReturnsModal();
        initCartDrawerAccordions();
      })
      .catch(function() {});
  });

  // Adds from inside an open drawer go through reloadCart() with the same stale
  // count. If a render landed on the empty state while the cart is not empty,
  // re-render once.
  document.addEventListener('theme:cart:change', function(event) {
    const cart = event.detail && event.detail.cart;
    if (!cart || !cart.item_count) return;
    const empty = document.querySelector('.cart__drawer [data-cart-empty]');
    if (empty && !empty.classList.contains('cart--hidden')) {
      document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
    }
  });

  function initCartDrawerAccordions() {
    document.querySelectorAll('.cart__drawer [data-accordion-trigger]').forEach(function(trigger) {
      if (trigger.dataset.accordionBound === 'true') return;
      trigger.dataset.accordionBound = 'true';
      trigger.addEventListener('click', function() {
        const open = trigger.classList.toggle('accordion-is-open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  // Run on initial page load (cart drawer is in DOM from group-overlay)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      refreshCartUI();
      initReturnsModal();
      initCartDrawerAccordions();
    });
  } else {
    refreshCartUI();
    initReturnsModal();
    initCartDrawerAccordions();
  }

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      // ... update some element on the page
    }
  });

  // Back to top button
  (function initBackToTop() {
    const button = document.querySelector('[data-back-to-top]');
    if (!button) return;

    const SCROLL_THRESHOLD = 300;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setVisible(isVisible) {
      button.classList.toggle('is-visible', isVisible);
      button.hidden = !isVisible;
      button.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      button.tabIndex = isVisible ? 0 : -1;
    }

    function updateVisibility(position) {
      setVisible(position > SCROLL_THRESHOLD);
    }

    function scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
      });
    }

    document.addEventListener('theme:scroll', function(event) {
      updateVisibility(event.detail.position);
    });

    button.addEventListener('click', scrollToTop);

    updateVisibility(window.pageYOffset || document.documentElement.scrollTop || 0);
  })();

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
